import React from 'react';

const EMAIL = 'contacto@orbiax.co';

const ServicesHero = () => {
  return (
    <section className="relative z-[1] pt-32 sm:pt-40 pb-16 sm:pb-20 px-5 sm:px-8 md:px-10">
      <div className="max-w-3xl mx-auto text-center">
        <h1
          style={{ fontSize: 'clamp(30px, 5.6vw, 58px)', lineHeight: 1.15, fontWeight: 500, letterSpacing: '-0.01em' }}
          className="text-black mb-6"
        >
          Todo lo que hacemos, en un solo lugar.
        </h1>
        <p
          className="text-black/60 mx-auto mb-8"
          style={{ fontSize: 'clamp(15px, 2vw, 18px)', lineHeight: 1.5, fontWeight: 400 }}
        >
          Cinco formas de dejar de operar como antes: consultoría, agentes de IA, automatización,
          aplicaciones a la medida y una integración que se adapta a tu stack.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <a
            href={`mailto:${EMAIL}`}
            className="inline-flex items-center gap-2 bg-black text-white text-[14px] font-medium px-6 py-3 rounded-full hover:opacity-80 transition-opacity"
          >
            Escríbenos
            <span aria-hidden="true">→</span>
          </a>
          <a
            href="/diagnostico-gratuito"
            className="inline-flex items-center gap-1 text-black text-[14px] font-medium border border-black/20 px-6 py-3 rounded-full hover:bg-black hover:text-white transition-colors duration-200"
          >
            Agendar diagnóstico
            <span aria-hidden="true">›</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;
